const DEFAULT_ICON_SIZE = "50px";

export default {
  props: {
    icon: {
      type: [Object, String, Boolean], // must contain src, alt and size props or just a src string
      required: false,
      default: false
    }
  },
  computed: {
    iconSrc() {
      return this.icon.src || this.icon;
    },
    iconAlt() {
      return this.icon.alt || "";
    },
    iconSize() {
      return this.icon.size || DEFAULT_ICON_SIZE;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/iconMixin.js